import axiosInstance from 'api/axiosInstance'

export const getCreators = async (params: {
    search: string | null
    page: number
}) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/browse-creators',
        params
    })

    return data
}

export const getFreeCreators = async (params: {
    search: string | null
    page: number
}) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/free-creators',
        params
    })

    return data
}

export const getTrendingCreators = async (params: {
    search: string | null
    page: number
}) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/trending-creators',
        params
    })

    return data
}

export const getLiveCreators = async (params: {
    search: string | null
    page: number
}) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/live-creators',
        params
    })

    return data
}

export const getCreatorsRecentSearch = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/recent-search'
    })

    return data?.data?.message ?? []
}

export const deleteCreatorsRecentSearch = async (payload: {
    search_id: string[]
}) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: '/api/user/recent-search',
        data: payload
    })

    return data
}
